import { COUNTRY_CODE } from '@uip-alpha/business-constants'

// 查询运费时效类型标签 1：快递；2：大件；3：冷运；4：医药；5：丰巢；6：同城；7：国际
const shipTypes = [
    {
        code: 1,
        name: 'express',
        text: '快递',
        active: true,
        cn: true,
        hk: true,
        tw: true
    },
    {
        code: 2,
        name: 'heavyCargo',
        text: '大件（20kg+）',
        cn: {
            'cn-cn': true,
            'cn-hkmctw': true,
            'hkmctw-cn': true,
            'hkmctw-hkmctw': true,
            'ibu-cn': false,
            'ibu-hkmctw': false,
            'cn-ibu': false,
            'hkmctw-ibu': false,
            'ibu-ibu': false
        },
        hk: false,
        tw: false
    },
    {
        code: 3,
        name: 'coldChain',
        text: '冷运',
        cn: {
            'cn-cn': true,
            'cn-hkmctw': true,
            'hkmctw-cn': true,
            'hkmctw-hkmctw': true,
            'ibu-cn': false,
            'ibu-hkmctw': false,
            'cn-ibu': false,
            'hkmctw-ibu': false,
            'ibu-ibu': false
        },
        hk: false,
        tw: false
    }
]
const additionalServiceList = [
    {
        name: '超时退费',
        code: 'overdue-refund',
        description:
            '1. 仅收寄路线为大陆互寄的标准快递、或即日到（T1即日件、SP101航空即日到、T106即日1630、T107即日1900）支持超时退费，其他时效服务类型（见Note中时效白名单）',
        link: '/opencms/opencms/cn/sc/express/additional_service/after-sales/overdue_return_premium/',
        availableService: ['T104', 'T801', 'SP101', 'T106', 'T1', 'T8'],
        // icon: overdueRefund,
        iconName: 'overdue-refund',
        originLocations: [COUNTRY_CODE.MAINLAND],
        destsLocations: [COUNTRY_CODE.MAINLAND],
        bothRequired: true,
        switch: false
    }
]

// 香港的countryCode
const CODE_OF_HK = COUNTRY_CODE.HK
// 澳门的countryCode
const CODE_OF_MACAO = COUNTRY_CODE.MAC
// 台湾的countryCode
const CODE_OF_TW = COUNTRY_CODE.TW
// 大陆的countryCode
const CODE_OF_CHINA = COUNTRY_CODE.MAINLAND
// 根据contryCode 判断是否是国外
const checkCountry = {
    isChina: countryCode => [CODE_OF_HK, CODE_OF_MACAO, CODE_OF_TW, CODE_OF_CHINA].indexOf(countryCode) > -1,
    isIBU: countryCode => [CODE_OF_HK, CODE_OF_MACAO, CODE_OF_TW, CODE_OF_CHINA].indexOf(countryCode) < 0,
    isHKMACAO: countryCode => [CODE_OF_HK, CODE_OF_MACAO, CODE_OF_TW].indexOf(countryCode) > -1,
    isMainland: countryCode => countryCode === CODE_OF_CHINA
}

// 附加费用的出现顺序优先级，数字越小越靠前，[IN15、IN23、IN100、IN104、IN16、IN156、IN157],顺序目前为这样
const serviceItemSortObj = {
    IN15: 1,
    IN23: 2,
    IN100: 3,
    IN104: 4,
    IN16: 5,
    IN156: 6,
    IN157: 7
}
export { shipTypes, additionalServiceList, checkCountry, serviceItemSortObj }



// WEBPACK FOOTER //
// ./src/pages/price/config.js